import { getImprintText } from 'gcs-common/slices/theme/themeSelectors';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import closeIcon from '../../img/close_white.svg';
import Button from '../Button/Button';
import styles from './styles.module.scss';

const Imprint = () => {
  const navigate = useNavigate();
  const imprintText = useSelector(getImprintText);

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <div>Impressum</div>
        <Button className={styles.noBorder} type="button" onClick={() => navigate(-1)}>
          <img src={closeIcon} alt="Zurück" />
        </Button>
      </div>
      <div className={styles.textWrapper}>
        <p>{imprintText}</p>
      </div>
    </div>
  );
};

export default Imprint;
